import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-auto",
    raised: ""
  }, {
    default: _withCtx(() => [
      (_ctx.matchOver)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(" VOTE ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(" VOTING ENDS IN ")
            ]),
            _: 1
          })),
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.timeLeft), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_1, [
            _createTextVNode(" at "),
            _createElementVNode("span", null, _toDisplayString(_ctx.endTime), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions)
    ]),
    _: 1
  }))
}